import { Button } from '@mui/material';

const style = {
  bgcolor: '#84d8c5',
  color: '#FFF',
  width: 170,
  transition: 'background-color 0.3s ease-in',
  border: '1px solid #84d8c5',
  '&:hover': {
    bgcolor: '#57af9b !important',
    borderColor: '#57af9b',
  },
};

export const ContainedButton = (props) => {
  return (
    <Button
      onClick={props.onClick}
      size="medium"
      sx={{ ...style, ...props.style }}
      variant="contained"
      startIcon={props.startIcon}
      disabled={props.disabled}
    >
      {props.btnTitle}
    </Button>
  );
};
